/**
 * Hero Section Element Visibility Rules
 * 
 * Controls visibility of hero section elements (LISTING_HERO experiment).
 */

import { AllowedExperimentKey } from '@tenants/types';
import { ExperimentElement, type VisibilityRule } from '../../types';

/**
 * Hero section visibility rules
 * 
 * Logic:
 * - Share/like buttons: desktop only, only when LISTING_HERO experiment is active
 *   BUT hide when STICKY_HEADER_TABS is active (sticky header has its own buttons)
 * - Other hero elements: always show (no rules needed)
 */
export const heroRules: Partial<Record<ExperimentElement, VisibilityRule>> = {
  [ExperimentElement.HERO_LAYOUT_V2]: {
    showWhen: {
      experiments: [AllowedExperimentKey.LISTING_HERO],
    },
  },

  [ExperimentElement.HERO_SHARE_BUTTON]: {
    showWhen: {
      experiments: [AllowedExperimentKey.LISTING_HERO],
      viewports: ['desktop'],
    },
    hideWhen: {
      experiments: [AllowedExperimentKey.STICKY_HEADER_TABS],
      viewports: ['desktop'],
    },
  },
  
  [ExperimentElement.HERO_LIKE_BUTTON]: {
    showWhen: {
      experiments: [AllowedExperimentKey.LISTING_HERO],
      viewports: ['desktop'],
    },
    hideWhen: {
      experiments: [AllowedExperimentKey.STICKY_HEADER_TABS],
      viewports: ['desktop'],
    },
  },
};
